import React from 'react';

import {
  defaultInventoryParameters,
  IInventoryParameters,
} from '~/src/dash/apiV2/forecasting/forecasting';
import { ISelectOption } from '~/src/dash/components/dropdowns/common';
import { FormBuilder } from '~/src/dash/components/forms/formBuilder';
import { IconV2 } from '~/src/dash/components/icons/IconV2';
import { highlightedDivStyle } from '~/src/dash/components/layout/common';
import { Col, Cols, Row, Rows, spacing, Text } from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';
import { useBaseConfig, useBaseStore } from '~/src/dash/views/base/contexts';
import { ForecastingFormContext } from '~/src/dash/views/tools/Forecasting/contexts';
import {
  generateInventoryParametersParamOptions,
  InventoryParametersCategory,
} from '~/src/dash/views/tools/Forecasting/InventoryParameters/config';

type InventoryParametersParams = {
  inventoryParameters: IInventoryParameters;
  inventoryParametersLists: Record<string, ISelectOption[]>;
  isLoaded: boolean;
};

export const InventoryParameters = ({
  inventoryParameters,
  inventoryParametersLists,
  isLoaded,
}: InventoryParametersParams) => {
  const { session, isSuperUser } = useBaseStore();

  const { Tools } = useBaseConfig();
  const cfg = Tools.Forecasting.Main.InventoryParameters;

  return (
    <ForecastingFormContext.Provider value={{ inventoryParametersLists }}>
      <Rows gap={spacing.medium}>
        <Row noPadding>
          <Rows smallPadding style={{ ...highlightedDivStyle, minWidth: '940px' }}>
            <Row
              style={{
                padding: '4px 8px 8px 8px',
              }}
            >
              <Text bold large color={publicaColors.black}>
                Inventory Parameters
              </Text>
            </Row>
            {/* ALL FORM BUILDERS */}
            {Object.values(cfg.categories).map((cat, i) => {
              return (
                <Row
                  smallVerticalPadding
                  style={{
                    borderTop: i === 0 ? 'none' : `1px solid ${publicaColors.lightGray}`,
                  }}
                >
                  <Rows>
                    {/* CATEGORY AND ICON */}
                    <Row noPadding>
                      <Cols gap={spacing.small} style={{ alignItems: 'center' }}>
                        <Col displayFlex>
                          <div style={{ height: '100%', display: 'flex' }}>
                            <IconV2 name={cat.iconName} small />
                          </div>
                        </Col>
                        <Col>
                          <Text bold small>
                            {cat.key}
                          </Text>
                        </Col>
                      </Cols>
                    </Row>
                    <Row noPadding>
                      <Rows>
                        {/* DESCRIPTION NOTES */}
                        <Row noPadding>
                          <Text small muted>
                            {cat.subText}
                          </Text>
                        </Row>
                        <Row noPadding>
                          <Text small bold>
                            Where
                          </Text>
                        </Row>
                        {/* FORM BUILDER */}
                        <Row noPadding>
                          <FormBuilder
                            object={inventoryParameters}
                            defaultObject={defaultInventoryParameters}
                            parameterOptions={generateInventoryParametersParamOptions(
                              cat.paramKeys,
                              session.publisher.ID,
                              isSuperUser,
                            )}
                            parameterCfg={cfg.params}
                            lists={inventoryParametersLists}
                            initialParameterKeys={
                              (
                                inventoryParameters.ActiveParameters as Record<
                                  InventoryParametersCategory,
                                  string[]
                                >
                              )[cat.key] || []
                            }
                            isLoading={!isLoaded}
                            customAddText={cat.addParamText}
                            errors={{}}
                            activeParametersKey={cat.key}
                            parentLabel={'Forecast'}
                          />
                        </Row>
                      </Rows>
                    </Row>
                  </Rows>
                </Row>
              );
            })}
          </Rows>
        </Row>
      </Rows>
    </ForecastingFormContext.Provider>
  );
};
